import type { NarrativeMedia } from '~/contracts/vdp/Narratives';
import type { SelectedWhyBuyMedia } from './selectWhyBuyMedia';

export const ASSET_CATEGORY_VEHICLE_INFOGRAPHICS =
  'ASSET_CATEGORY_VEHICLE_INFOGRAPHICS';

export type WhyBuyAssetType =
  | 'infographic'
  | 'placeholder'
  | 'stock image'
  | 'unknown';

function isStockImageCategory(assetCategory?: string): boolean {
  return (
    Boolean(assetCategory) &&
    assetCategory !== ASSET_CATEGORY_VEHICLE_INFOGRAPHICS
  );
}

export function getWhyBuyAssetType(
  media: SelectedWhyBuyMedia | undefined,
  isPlaceholderShown = false
): WhyBuyAssetType {
  if (!media || isPlaceholderShown) {
    return 'placeholder';
  }
  if (media.assetCategory === ASSET_CATEGORY_VEHICLE_INFOGRAPHICS) {
    return 'infographic';
  }

  return media.assetCategory ? 'stock image' : 'unknown';
}

export function getWhyBuyCardAnalytics(
  { bulletType, media }: { bulletType?: string; media?: SelectedWhyBuyMedia },
  isPlaceholderShown = false
) {
  return {
    assetType: getWhyBuyAssetType(media, isPlaceholderShown),
    bulletType,
    matchRank: media?.matchRank,
    mimeType: media?.mimeType
  };
}

export function hasWhyBuyStockImagery(
  bulletPoints?: ReadonlyArray<{ media?: NarrativeMedia | null }> | null
): boolean {
  return (bulletPoints ?? []).some(({ media }) =>
    (media?.assets ?? []).some(({ assetCategory }) =>
      isStockImageCategory(assetCategory)
    )
  );
}

export function getWhyBuyNarrativesAnalytics(
  narratives: ReadonlyArray<{ media?: SelectedWhyBuyMedia; title: string }>
) {
  return narratives.map(({ media, title }) => ({
    assetType: getWhyBuyAssetType(media),
    matchRank: media?.matchRank,
    mimeType: media?.mimeType,
    title
  }));
}
